export const LOAD_HEIRS = 'heirs/LOAD_HEIRS';
